export default __webpack_public_path__ + "fff8eca8e69ba4c743903a96a434ab56.svg";